import { getReportMetricTexts, ReportMetricRankedItem } from '../../content/REPORT_METRIC_TEXTS'
import { useSelectReportData } from '../../hooks/useSelectReportData'
import SubPageMetric from './SubPageMetric'

const Page9 = () => {
  const { metricItems } = useSelectReportData()
  const metricDetails = metricItems.map((m): ReportMetricRankedItem => {
    return getReportMetricTexts(m.param_key, m.rank, m.value)
  })

  return (
    <div>
      <hr />
      <div>
        <p
          style={{ padding: '30px 30px 0 30px' }}
          className={'title-bold-2'}
        >
          Glucose data analysis
        </p>
        <p
          style={{ padding: '0 30px 0 30px' }}
          className={'description-sub'}
        >
          Here we take a closer look at all the metrics mentioned earlier, and give unique insights for improving them.
        </p>
        {metricDetails.map((metricProps, i) => {
          return (
            <SubPageMetric
              key={i}
              {...metricProps}
            />
          )
        })}
      </div>
    </div>
  )
}

export default Page9
